import { Component, Inject, ElementRef, OnInit, ViewChild, AfterViewInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AppAttendanceTypesService } from '../../../core/services/appAttendanceTypesService.service';
import { AppAttendanceTypes } from '../../../core/models/appAttendanceTypes.model';
import { AppWorkCenters } from '../../../core/models/appWorkCenters.model';
import { AppWorkCentersService } from '../../../core/services/appWorkCentersService.service';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { EditCentrosDialog } from '../edit-centros-dialog/edit-centros-dialog.component';
import { EditTiposDialog } from '../edit-tipos-dialog/edit-tipos-dialog.component';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-config-marcajes-dialog',
  templateUrl: './config-marcajes-dialog.component.html',
  styleUrls: ['./config-marcajes-dialog.component.scss'],
  providers: [AppAttendanceTypesService, AppWorkCentersService]
})
export class ConfigMarcajesDialog {

  panelIcon = 'search-location'; // font awesome icon
  panelTitle = 'Configuración de marcaje';
  panelDescription = 'Configuración de marcaje';

  @ViewChild('scrollableSection', { static: false }) scrollableSection: ElementRef;
  @ViewChild('dataGrid') dataGrid: any;

  workCenters: AppWorkCenters[];
  attendanceTypes: AppAttendanceTypes[];
  configuredWorkCenters: [];
  configuredWorkCenterCodes: Number[] = [];
  enableNew: boolean = false


  constructor(
    public dialogRef: MatDialogRef<ConfigMarcajesDialog>,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    protected _editDialog: MatDialog,
    public appAttendanceTypesService: AppAttendanceTypesService,
    public appWorkCentersService: AppWorkCentersService,
    protected _messageDialog: MessageDialog,

  ) {
    this.panelTitle = `${this.panelTitle} (${this.inputData.name})`;

  }

  private loadModels(): void {
    this.enableNew = false

    if (this.dataGrid?.instance) {
      this.dataGrid.instance.beginCustomLoading('');
    }

    // Cargar attendanceTypes
    this.appAttendanceTypesService.getAllModels(this.inputData.company1).subscribe(
      (attendanceTypes) => {
        if (attendanceTypes.message) {
          console.error('Error al cargar attendanceTypes:', attendanceTypes[this.inputData.company1].message);
        } else {
          this.attendanceTypes = attendanceTypes[this.inputData.company1];
        }
      },
      (error) => {
        console.error('Error al cargar attendanceTypes:', error);
      }
    );

    // Cargar workCenters
    this.appWorkCentersService.getAllModels(this.inputData.company1).subscribe(
      (workCenters) => {
        if (workCenters.message) {
          console.error('Error al cargar attendanceTypes:', workCenters.message);
          this.enableNew = true
        } else {
          this.workCenters = workCenters[this.inputData.company1];
          this.configuredWorkCenterCodes = this.workCenters.map(center => center.workplaceCode);
          this.enableNew = true
        }

      },
      (error) => {
        console.error('Error al cargar workCenters:', error);
      },
      () => {
        // Finalizar la carga después de completar todas las solicitudes
        if (this.dataGrid?.instance) {
          this.dataGrid.instance.endCustomLoading();
        }
      }
    );
  }


  ngOnInit(): void {

    this.loadModels();
  }

  onToolbarPreparing(e) {
    const newButtonTemplate = {
      location: 'after',
      template: 'addNew'
    };

    e.toolbarOptions.items.unshift(newButtonTemplate);
  }

  closePopUp() {
    this.dialogRef.close();
  }

  onSelectedTabChange() {
    // this.dataGrid.instance.repaint();
  }

  onEditorPreparing(e): void {
    if (e.parentType === 'searchPanel') {
      e.editorOptions.stylingMode = 'underlined';
    }
  }

  calculateEntryValue(rowData) {
    return rowData.entry ? 'Entrada' : 'Salida';
  }

  calculateEntryValueYesNo(rowData) {
    return rowData.imputable ? 'Sí' : 'No';
  }

  onClickDisableWorkCenter(data: any): void {
    this._messageDialog.ShowQuestion(

      `Se ${data.data.enabled ? `deshabilitará ${data.data.name} y no se podrán realizar marcajes en este centro` : `habilitará ${data.data.name}  y se podrán realizar marcajes en este centro`}`,
      `${data.data.enabled ? 'Deshabilitar' : 'Habilitar'}`

    )
      .then(result => {
        if (result.value) {
          this.appWorkCentersService.toggleEnable(data.data.workCenter1, data.data.enabled).subscribe(
            (response) => {
              this.loadModels()
            },
            (error) => {
              console.error('Error al editar:', error);
            }
          );

        }
      })

  }

  onClickDisableAttendanceType(data: any): void {
    this._messageDialog.ShowQuestion(

      `Se ${data.data.enabled ? `deshabilitará ${data.data.name} y no se podrán realizar marcajes de este tipo` : `habilitará ${data.data.name}  y se podrán realizar marcajes de este tipo`}`,
      `${data.data.enabled ? 'Deshabilitar' : 'Habilitar'}`

    )
      .then(result => {
        if (result.value) {
          this.appAttendanceTypesService.toggleEnable(data.data.attendanceType1, data.data.enabled).subscribe(
            (response) => {
              this.loadModels()
            },
            (error) => {
              console.error('Error al editar:', error);
            }
          );
        }
      })

  }

  onClickEditCenter(e): void {

    const dialogRef = this._editDialog.open(EditCentrosDialog, {
      width: '100%',
      data: { data: e, companyName: this.inputData.name, companyData: this.inputData }
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[1];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
      this.loadModels()
    });
  }

  onClickEditType(e): void {
    const dialogRef = this._editDialog.open(EditTiposDialog, {
      width: '100%',
      data: { data: e, companyName: this.inputData.name, companyData: this.inputData }
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[1];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
      // this.loadData();
    });
  }

  onClickAddWorkCenter(): void {

    const dialogRef = this._editDialog.open(EditCentrosDialog, {
      width: '100%',
      data: { data: null, companyName: this.inputData.name, companyData: this.inputData, configuredWorkCenterCodes: this.configuredWorkCenterCodes }
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[1];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
      this.loadModels()
    });
  }

  onClickAddAttendanceType(): void {
    const dialogRef = this._editDialog.open(EditTiposDialog, {
      width: '100%',
      data: { data: null, companyName: this.inputData.name, companyData: this.inputData }

    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[1];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
      this.loadModels()
    });
  }



}